var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLindekinLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_197",
    "data-name": "Group 197",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.417,
    height: 16.417,
    viewBox: "0 0 16.417 16.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M485.5,172.815h0v-6.021c0-2.945-.634-5.214-4.077-5.214a3.575,3.575,0,0,0-3.22,1.77h-.048v-1.495H474.9v10.96h3.4v-5.427c0-1.429.271-2.811,2.04-2.811,1.744,0,1.77,1.631,1.77,2.9v5.336Z",
    transform: "translate(-469.088 -156.398)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M302.244,170.176h3.4v10.96h-3.4Z",
    transform: "translate(-301.973 -164.72)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M295.767,0a1.981,1.981,0,1,0,1.971,1.971A1.972,1.972,0,0,0,295.767,0Z",
    transform: "translate(-293.796)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLindekinLogo);
export default __webpack_public_path__ + "static/media/lindekin-logo.82c2bdb6d6a46f2beeae7adf0b99a838.svg";
export { ForwardRef as ReactComponent };